export const isAxiosRequestAborted = (error) => {
  const code = String(error?.code || "").trim().toUpperCase();
  if (code === "ECONNABORTED" || code === "ERR_CANCELED") {
    return true;
  }

  const name = String(error?.name || "").trim().toLowerCase();
  if (name === "cancelederror") {
    return true;
  }

  const message = String(error?.message || "").trim().toLowerCase();
  if (!message) {
    return false;
  }

  return (
    message.includes("request aborted") ||
    message.includes("aborted") ||
    message.includes("canceled") ||
    message.includes("cancelled")
  );
};

